import React from 'react';
import { Globe, LineChart, BellRing, Sparkles, Layers, Shield } from 'lucide-react';

export const FeatureGrid: React.FC = () => {
  const features = [
    {
      icon: <Globe className="w-6 h-6 text-emerald-500" />,
      title: 'Universal Store Tracking',
      description:
        'Our resilient multi-tier extraction engine monitors product pages across any merchant without relying on fragile site-specific scrapers.',
    },
    {
      icon: <LineChart className="w-6 h-6 text-teal-500" />,
      title: 'Interactive History Charts',
      description:
        'Explore verified chronological price movements across 30-day, 90-day, and all-time horizons to spot authentic bargains vs deceptive markups.',
    },
    {
      icon: <BellRing className="w-6 h-6 text-amber-500" />,
      title: 'Precision Drop Alerts',
      description:
        'Define exact target price thresholds or trigger alerts on percentage drops with verified structural delivery deduplication.',
    },
    {
      icon: <Layers className="w-6 h-6 text-blue-500" />,
      title: 'Web & Extension Sync',
      description:
        'Add items on your laptop via the Chrome extension and review your organized portfolio seamlessly on the web dashboard on any device.',
    },
    {
      icon: <Shield className="w-6 h-6 text-indigo-500" />,
      title: 'Privacy-First Architecture',
      description:
        'We never monitor your browsing history or track adjacent tabs. Only the product links you explicitly submit are evaluated.',
    },
    {
      icon: <Sparkles className="w-6 h-6 text-rose-500" />,
      title: 'Multi-Currency & RTL',
      description:
        'Full support for USD, SAR, AED, EUR, GBP, EGP, and more with dedicated Right-to-Left Arabic layout translation.',
    },
  ];

  return (
    <section id="features" className="py-20 bg-slate-50 dark:bg-slate-900/40 border-y border-slate-200 dark:border-slate-800 transition-colors">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 dark:text-slate-100 sm:text-4xl">
            Built for Smart, Data-Driven Shoppers
          </h2>
          <p className="mt-4 text-sm text-slate-600 dark:text-slate-400">
            Everything you need to time your purchases perfectly without spending hours manually checking product tabs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, i) => (
            <div
              key={i}
              className="p-6 rounded-2xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-sm hover:shadow-md transition-shadow flex flex-col justify-between"
            >
              <div>
                <div className="w-12 h-12 rounded-xl bg-slate-50 dark:bg-slate-800 flex items-center justify-center mb-4">
                  {feature.icon}
                </div>
                <h3 className="text-base font-semibold text-slate-900 dark:text-slate-100 mb-2">
                  {feature.title}
                </h3>
                <p className="text-xs text-slate-600 dark:text-slate-400 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
